import "./style.css";
import ContentPopUp from "./components/ContentPopUp/ContentPopUp";
import { useEffect, useState } from "react";
import Lines from "./components/Lines/Lines";
import Layer from "./components/Layer/Layer";
import JourneyBox from "./components/JourneyBox/JourneyBox";
import { Box, Grid } from "@mui/material";
import Navbar from "../../../components/Navbar";

const Architecture = () => {
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedJourney, setSelectedJourney] = useState(null);
  const [data, setData] = useState({});

  // Fetch bubble content data
  useEffect(() => {
    fetch("/json/diagramData.json")
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems : "center",
        flexDirection: "column",
      }}
    >
      <Navbar />
      <Grid
        item
        justifyContent={"center"}
        className="container-box"
      >
        <h1>
          {data.title}
        </h1>
        <div className="main-box">
          <div className="side-pannel">
            <JourneyBox
              selectedJourney={selectedJourney}
              setSelectedJourney={setSelectedJourney}
              setSelectedNode={setSelectedNode}
            />
            <ContentPopUp
              selectedNode={selectedNode}
              setSelectedNode={setSelectedNode}
              selectedJourney={selectedJourney}
            />
          </div>

          <div className="diagram-box">
            <Lines selectedJourney={selectedJourney} />
            {data &&
              data?.layers?.map((layer, index) => {
                return (
                  <Layer
                    key={index}
                    layerData={layer.block}
                    selectedNode={selectedNode}
                    setSelectedNode={setSelectedNode}
                    selectedJourney={selectedJourney}
                  />
                );
              })}
          </div>
        </div>
      </Grid>
      {/* </div> */}
    </Box>
  );
};

export default Architecture;
